import { AxiosError } from 'axios';

import { ZOR_MEMBER_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { PaginatedZorMembers } from '@/types/zor.member.type';

export interface GetAllZorMembersParams {
  page?: number;
  limit?: number;
}

export const getAllZorMembers = async (
  params: GetAllZorMembersParams = {}
): Promise<ApiResponse<PaginatedZorMembers>> => {
  try {
    const response = await apiManager.get(`${ZOR_MEMBER_API_URL}/all`, {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 10,
      },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
